export default {
  test: '<q class="text-blue-500">test</q>',
}
